'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function scriptInjector() {
    var head = window.document.head || window.document.getElementsByTagName("head")[0];
    var registry = [];
    var loader = function loader(src, callback) {
        // If the script has already been injected, return the callback if there is one
        // or return a promise.
        if (registry.indexOf(src) !== -1) {
            if (callback !== undefined) {
                return callback();
            }
            return new Promise(function (resolve, reject) {
                resolve();
            });
        }
        // Add the script to the registry, inject the script tag, and return the callback
        // if it is provided.
        registry.push(src);
        var script = document.createElement("script");
        script.type = "text\/javascript";
        script.async = "true";
        script.src = src;
        head.appendChild(script);
        if (callback !== undefined) {
            script.onload = callback;
            script.onerror = callback;
            script.onreadystatechange = callback;
            return true;
        }
        // If a callback isn’t provided, return a promise.
        var promise = new Promise(function (resolve, reject) {
            script.onerror = function () {
                reject(script);
            };
            script.onload = function () {
                resolve(script);
            };
            script.onreadystatechange = function () {
                resolve(script);
            };
        });
        return promise;
    };
    return loader;
};

exports.default = scriptInjector;